import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TwitchStatus from './TwitchStatus';

const MemberCard = ({ member }) => {
  const navigate = useNavigate();
  const [twitchUsername, setTwitchUsername] = useState(null);

  useEffect(() => {
    // Check if member has a Twitch link
    if (member?.links) {
      const twitchLink = member.links.find(
        (link) =>
          link.url.includes('twitch.tv') ||
          link.label.toLowerCase() === 'twitch'
      );
      if (twitchLink) {
        // Extract username correctly from URL
        let username = null;
        try {
          const url = new URL(twitchLink.url);
          username = url.pathname.replace(/^\/+/, '');
        } catch (e) {
          console.error('Invalid URL format:', twitchLink.url);
        }

        if (username && username.length > 0) {
          setTwitchUsername(username);
        }
      }
    }
  }, [member]);

  if (!member) return null;

  const handleCardClick = () => {
    navigate(`/members/${member.id}`);
  };

  const handleLinkClick = (e) => {
    // Prevent the card click from triggering when clicking on links inside the card
    e.stopPropagation();
  };

  return (
    <div
      className='bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border rounded-lg shadow-md overflow-hidden transition-all hover:shadow-lg flex flex-col h-full cursor-pointer hover:translate-y-[-5px]'
      onClick={handleCardClick}
    >
      <div className='relative'>
        <img
          src={member.image}
          alt={member.name}
          className='w-full object-cover object-top h-80'
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/600x800?text=No+Image';
          }}
        />
      </div>

      <div className='p-4 flex flex-col flex-grow'>
        <h3 className='text-lg font-bold text-primary-700 dark:text-primary-400'>
          {member.name}
        </h3>
        <p className='text-dimensional-600 dark:text-dimensional-400'>
          {member.role}
        </p>

        {twitchUsername && (
          <TwitchStatus
            username={twitchUsername}
            handleLinkClick={handleLinkClick}
          />
        )}

        <p className='whitespace-pre-line mt-2 text-sm text-dimensional-700 dark:text-dimensional-300'>
          {member.shortBio}
        </p>

        <div className='mt-auto pt-4'>
          <Link
            to={`/members/${member.id}`}
            className='inline-block w-full text-center px-4 py-2 bg-primary-600 hover:bg-primary-700 dark:bg-primary-800 dark:hover:bg-primary-700 text-primary-400 rounded-md'
            onClick={handleLinkClick}
          >
            View Profile
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MemberCard;
